export default function HistorySection() {
  const milestones = [
    {
      year: "2008",
      title: "CPVA Founded",
      description: "Established as the first organization to bridge pharmacy and veterinary medicine in Canada.",
      icon: "ri-flag-line"
    },
    {
      year: "2012",
      title: "National Recognition",
      description: "Gained official recognition from Health Canada as a leading voice in integrated healthcare.",
      icon: "ri-government-line"
    },
    {
      year: "2015",
      title: "Education Hub Launch",
      description: "Launched our comprehensive online education platform for continuing professional development.",
      icon: "ri-graduation-cap-line"
    },
    {
      year: "2018",
      title: "Research Initiative",
      description: "Established the One Health Research Initiative, funding collaborative studies across disciplines.",
      icon: "ri-microscope-line"
    },
    {
      year: "2021",
      title: "Wellness Academy",
      description: "Opened the CPVA Wellness Academy, providing mental health support for healthcare professionals.",
      icon: "ri-heart-pulse-line"
    },
    {
      year: "2024",
      title: "Digital Innovation",
      description: "Launched digital health initiatives connecting pharmacies and veterinary clinics nationwide.",
      icon: "ri-smartphone-line"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Journey
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Over 15 years of innovation, collaboration, and dedication to advancing healthcare for people and animals across Canada.
          </p>
        </div>
        
        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-blue-200"></div>
          
          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div key={index} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                <div className={`w-1/2 ${index % 2 === 0 ? 'pr-12 text-right' : 'pl-12 text-left'}`}>
                  <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
                    <div className="text-2xl font-bold text-blue-600 mb-2">{milestone.year}</div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">{milestone.title}</h3>
                    <p className="text-gray-600">{milestone.description}</p>
                  </div>
                </div>
                
                <div className="relative flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full border-4 border-white shadow-lg z-10">
                  <i className={`${milestone.icon} text-white text-xl`}></i>
                </div>
                
                <div className="w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}